import { useState } from 'react';

import { useSetFavorite } from '@entities/search-run';

interface FavoriteTarget {
  searchId: string;
  runId: string;
  vehicleId: string;
}

/** Какое действие не удалось: от него зависит текст сообщения. */
export type FavoriteFailure = 'add' | 'remove';

/**
 * Сердечко одного автомобиля (BE-581, FE-586).
 *
 * Отметка меняется сразу — кеш правит `useSetFavorite`, — а сбой откатывает
 * её и оставляет здесь, **у этой карточки**, причину: сообщение стоит рядом с
 * сердечком, которое вернулось назад, а не где-то вверху списка.
 *
 * Пока запрос в пути, повторное нажатие игнорируется: два встречных запроса
 * (`PUT`, следом `DELETE`) сервер может применить в любом порядке, и сердечко
 * разошлось бы с тем, что записано.
 */
export function useFavoriteToggle({ searchId, runId, vehicleId }: FavoriteTarget) {
  const mutation = useSetFavorite();
  const [failed, setFailed] = useState<FavoriteFailure | null>(null);

  const toggle = (favorite: boolean) => {
    if (mutation.isPending) return;
    setFailed(null);
    mutation.mutate(
      { searchId, runId, vehicleId, favorite },
      {
        onError: () => {
          setFailed(favorite ? 'add' : 'remove');
        },
      },
    );
  };

  return { toggle, failed, pending: mutation.isPending };
}
